import DelectoryApi from '../lib/DelectoryApi';
import Debug from 'debug';
const debug = Debug('delectable');

/**
 * Creates a new api plugin instance with options
 * @param {Object} options
 * @param {String} options.delectoryApi The instance of either server/api or client/api
 * @returns {DelectoryApiPlugin}
 */
function DelectoryApiPlugin(options) {
  options = options || {};
  var delectoryApi = new DelectoryApi(options);
  /**
   * @class DelectoryApiPlugin
   */
  return {
    name: 'DelectoryApiPlugin',
    plugContext: function plugContext() {

      return {
        /**
         * Provides full access to the slugManager in the action context
         * @param {Object} actionContext
         */
        plugActionContext: function plugActionContext(actionContext) {
          actionContext.delectoryApi = delectoryApi;
        },
        /**
         * Provides full access to delectoryApi in the component context
         * @param {Object} componentContext
         */
        plugComponentContext: function plugComponentContext(componentContext) {
          componentContext.delectoryApi = delectoryApi;
        },
        /**
         * Provides full access to delectoryApi in the store context
         * @param {Object} storeContext
         */
        plugStoreContext: function plugStoreContext(storeContext) {
          storeContext.delectoryApi = delectoryApi;
        },

        dehydrate: function() {
          return {
            delectoryApi: delectoryApi.getAuthCredentials()
          };
        },

        rehydrate: function(state) {
          delectoryApi.setAuthCredentials(state.delectoryApi);
        }
      };
    }
  };
}

export default DelectoryApiPlugin;



// WEBPACK FOOTER //
// banquet/plugins/DelectoryApiPlugin.js